<template>
  <div>
    <iframe :src="getFilesUrl(fileUrl)" id="iframe" style="width: 100%; height: 100vh"></iframe>
  </div>
</template>

<script>
export default {
  name: 'WordParser',
  props: {
    fileUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      output: '',
      imgVisbleURL: 'https://view.officeapps.live.com/op/view.aspx?src=',
      // imgVisbleURL: 'https://view.xdocin.com/view?src=',
    }
  },
  methods: {
    getFilesUrl(url) {
      return this.imgVisbleURL + url
    },
  },
}
</script>

<style lang="less" scoped></style>
